import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useAbility } from '@casl/react';
import { AbilityContext } from './permissions/Can';

export const hasAccessToCompanySettings = (itemsNumber: number): boolean => {
  const { currentAccount } = useSelector((state: RootState) => state.user);
  const context = useSelector((state: RootState) => state.app.context);
  const ability = useAbility(AbilityContext);
  const isConnectContext = context === 'connect';
  const customer = isConnectContext ? currentAccount?.partnership?.customer : currentAccount?.customer;
  const isWeChoooseContext = ['wechooose', 'connect'].includes(context);
  const hasCustomerOrIsPartnership = context === 'connect' || (!!customer && context === 'wechooose');
  const canViewCompanySettings = ability.can('view', 'CompanySettings') || context === 'connect';

  return canViewCompanySettings && isWeChoooseContext && hasCustomerOrIsPartnership && itemsNumber > 0;
};
